import React, { ChangeEventHandler, FC, useMemo } from "react";
import useWindowDimensions from "../../hooks/useWindowDimensions";
import { PasswordInput } from "../../components/ui/password-input";
import "./CustomPasswordInput.scss";

interface ICustomPasswordInput {
  label?: string;
  placeholder?: string;
  className?: string;
  value: string;
  onChange: ChangeEventHandler<HTMLInputElement>;
}

const CustomPasswordInput: FC<ICustomPasswordInput> = ({
  label,
  placeholder,
  value,
  className = "",
  onChange,
}) => {
  const [show] = React.useState(false);
  // const handleClick = () => setShow(!show);
  const { size } = useWindowDimensions();

  const inputMemo = useMemo(
    () => (
      <div className={`container__custom__password__input ${className}`}>
        {label && <span className="label">{label}</span>}
        <PasswordInput
          className="custom__input"
          type={show ? "text" : "password"}
          placeholder={placeholder}
          value={value}
          onChange={onChange}
        />
      </div>
    ),
    // eslint-disable-next-line
    [size.width, value, className, label, show]
  );

  return <>{inputMemo}</>;
};

export default CustomPasswordInput;
